<template>
  <sSelect
    :disabled="disabled"
    filterable
    :multiple="multiple"
    :placeholder="$t('OrgSettings.shoiseSetting')"
    :value.sync="mutableValue"
    @update:value="handleChange">
    <sOption
      v-for="item in settings"
      :key="item.settingId"
      :label="`${item.settingTitle} (${item.settingOldCode})`"
      :value="item.settingId"/>
  </sSelect>
</template>
<script>
import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  name: 'settingsSelect',
  data() {
    return {
      settings: [],
    }
  },
  methods: {
    handleChange(settingId) {
      this.$emit('on-change', settingId)
      /*this.$emit('on-change', v, id, title)*/
    }
  },
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  async created() {
    await organizer_setting_api.getSettingView()
      .then((res) => {
        this.settings = res
      })
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
